<template>
	<router-link
		tag="div"
		:to="{ name: 'index', params: { nickname: friend.nickname } }"
		class="dashboard__content__chats__item d-flex align-items-center"
	>
		<vs-avatar
			class="dashboard__content__chats__item__avatar mr-3"
			size="50"
			:badge="friend.online"
			badge-color="success"
			circle
			dark
		>
			<!-- :badge="undefined" -->
			<img
				v-if="friend.profilePicture"
				:src="friend.profilePicture"
				:alt="friend.name"
			/>
			<template v-if="!friend.profilePicture" #text>
				{{ friend.name }}
			</template>
		</vs-avatar>
		<div
			class="dashboard__content__chats__item__info d-flex w-100 justify-content-between"
		>
			<div class="dashboard__content__chats__item__text">
				<p
					class="dashboard__content__chats__item__text__name text--primary m-0"
				>
					{{ friend.name }}
				</p>
				<p
					class="dashboard__content__chats__item__text__last-message text--secondary mb-0"
				>
					Hey How Are you?
				</p>
			</div>
			<div
				class="dashboard__content__chats__item__additional d-flex flex-column align-items-end"
			>
				<p
					class="dashboard__content__chats__item__additional__time text--secondary m-0"
				>
					7:52
				</p>
				<div
					class="dashboard__content__chats__item__additional__unread-messages mb-0"
				>
					3
				</div>
			</div>
		</div>
	</router-link>
</template>

<script>
export default {
	props: { friend: Object }
}
</script>

<style></style>
